// components/Footer.js
import React from 'react';
import styles from './Footer.module.scss';
import logo from '../../logo2.png';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.footerContent}>
          <div className={styles.footerSection}>
            <img src={logo} alt="logo" />
            {/*<p>We purchase luxury watches at competitive prices. Get the best value for your premium timepieces.</p>*/}
            <div className={styles.contactInfo}>
              <p><i className="fas fa-phone"></i>+381 60 5809797</p>
              <p><i className="fas fa-envelope"></i>otkuptrevia@gmail.com</p>
              {/*<p><i className="fas fa-map-marker-alt"></i> Luxury Street 123, Belgrade</p>*/}
            </div>
          </div>

          <div className={styles.footerSection}>
            <h4>Gde se nalazimo?</h4>
            <div className={styles.mapWrapper}>
              <iframe
                title="Lokacija na mapi"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2838.295954595732!2d20.19644737617999!3d44.65230468724219!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475a14667015d671%3A0xc46db75dcc84f26b!2sMilo%C5%A1a%20Obrenovi%C4%87a%2074%2C%20Obrenovac%2011500!5e0!3m2!1sen!2srs!4v1758709999213!5m2!1sen!2srs"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>

          <div className={styles.footerSection}>
            <h4>Šta sve otkupljujemo?</h4>
            <ul>
              <li><a href="#">Ručne i džepne satove</a></li>
              <li><a href="#">Zlato</a></li>
              <li><a href="#">Srebro</a></li>
              <li><a href="#">Dijamante</a></li>
              <li><a href="#">Penkala i upaljače</a></li>
              <li><a href="#">Ordenja i medalje</a></li>
              <li><a href="#">Zlatnike i star novac</a></li>
              <li><a href="#">Stari nakit</a></li>
              <li><a href="#">Druge starine</a></li>
            </ul>
          </div>

          {/*<div className={styles.footerSection}>*/}
          {/*  <h4>QUICK LINKS</h4>*/}
          {/*  <ul>*/}
          {/*    <li><a href="#">How It Works</a></li>*/}
          {/*    <li><a href="#">Valuation Process</a></li>*/}
          {/*    <li><a href="#">Payment Options</a></li>*/}
          {/*    <li><a href="#">Testimonials</a></li>*/}
          {/*    <li><a href="#">FAQ</a></li>*/}
          {/*  </ul>*/}
          {/*</div>*/}

          <div className={styles.footerSection}>
            {/*<h4>BUSINESS HOURS</h4>*/}
            {/*<div className={styles.businessHours}>*/}
            {/*  <p>Monday - Friday: 9:00 - 18:00</p>*/}
            {/*  <p>Saturday: 10:00 - 16:00</p>*/}
            {/*  <p>Sunday: Closed</p>*/}
            {/*</div>*/}
            <h4>Društvene mreže</h4>
            <div className={styles.socialLinks}>
              {/*<a href="#"><i className="fab fa-facebook-f"></i></a>*/}
              <a href="https://www.instagram.com/otkup_antikviteta_trevia/"><i className="fab fa-instagram"></i></a>
              {/*<a href="#"><i className="fab fa-twitter"></i></a>*/}
            </div>
          </div>
        </div>

        <div className={styles.footerBottom}>
          <p>&copy; {new Date().getFullYear()} TREVIA OTKUP. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;